export const API_KEY_GET_INSTANT_MESSAGES_LIST = "get-instant-messages-list";
export const API_KEY_GET_CHAT = "get-chat-instance";
export const API_KEY_GET_CHAT_ADMIN = "get-admin-chat-instance";
export const API_KEY_GET_CATEGORIES = "get-chat-categories";
export const API_KEY_GET_ADMIN_CHATS = "get-admin-chats";
